import React, { useContext, useRef } from 'react';
import { AppContext } from './AppContext';

const { width, height } = { width: window.innerWidth, height: window.innerHeight };

const MYDATProfilePicSelector = ({ onImagePicked, style }) => {
  const { currentUser, profileImageUrl } = useContext(AppContext);
  const fileInputRef = useRef(null);

  const profileImageSource = currentUser && profileImageUrl ? profileImageUrl : require('./assets/defaultProfilePicProfile.png');

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      onImagePicked(imageUrl);
    }
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  return (
    <div
      onClick={handleClick}
      style={{ ...styles.touchableOpacity, ...style }}
    >
      <div
        style={{

          ...styles.touchableOpacity,
        }}
      >
        <div style={styles.imageContainer}>
          <img src={profileImageSource} alt="Profile" style={styles.image} />
        </div>
      </div>
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
    </div>
  );
};

const styles = {
  touchableOpacity: {
    width   : '165px',
    height  : '165px',
    zIndex  : 200,
    cursor  : 'pointer',
    display : 'block',
  },
  imageBackground: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: `url(${require('./assets/ProfilePicBG.png')})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  imageContainer: {
    width      : '87%', 
        height     : '78%',
        margin     : '0 auto',   // ⬅️ centers the inner square
        overflow   : 'hidden',
  },
  image: {
    display: 'flex',
    justifyContent: 'center',
    alignSelf: 'center',
    margin: '0 auto',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
};

export default MYDATProfilePicSelector;
